export enum OfflineStatus {
  NO_OFFLINE = <any>'noOffline',
  DOWNLOADING = <any>'downloading',
  DOWNLOADED = <any>'downloaded',
  UPDATE_AVAILABLE = <any>'updateAvailable'
}
